export default __webpack_public_path__ + "static/media/thumbsUpGreen.cd68f050.svg";